import { render, staticRenderFns } from "./ChildExpenseTypeForm.vue?vue&type=template&id=f8f219fe"
import script from "./ChildExpenseTypeForm.vue?vue&type=script&lang=js"
export * from "./ChildExpenseTypeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports